/**
 * @class LicenseProduct
 */
export default class LicenseProduct {
    /**
     * @param {Number} id
     * @param {String} name
     * @param {Number} availableCount
     * @param {Number} totalCount
     */
    constructor(id, name) {
        this._id = id;
        this._name = name;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - LicenseProduct");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {Number}
     */
    get availableCount() {
        return this._availableCount;
    }

    /**
     * @param {Number} availableCount
     */
    set availableCount(availableCount) {
        this._availableCount = availableCount;
    }

    /**
     * @return {Number}
     */
    get totalCount() {
        return this._totalCount;
    }

    /**
     * @param {Number} totalCount
     */
    set totalCount(totalCount) {
        this._totalCount = totalCount;
    }

    /**
     * @return {String}
     */
    toString() {
        return "LicenseProduct (" + this._id + ")";
    }
}
